module.exports = __webpack_public_path__ + "assets/img/7_823.da547e78.jpg";